'use client';

import React from 'react';
import { Chip } from '@mui/material';
import { useErrorCounts } from '@/contexts/ErrorCountsContext';

export const AISuggestedFixesChip: React.FC = () => {
  const { pendingAiSuggestions, loading } = useErrorCounts();

  if (loading || pendingAiSuggestions === 0) {
    return null;
  }

  // Amber/warning, not error red: pending AI suggestions are opportunities to
  // improve listings, not failures that need fixing.
  return (
    <Chip
      label={pendingAiSuggestions.toLocaleString('en-US')}
      color='warning'
      size='small'
      role='img'
      aria-label={`${pendingAiSuggestions.toLocaleString('en-US')} pending AI suggestion${pendingAiSuggestions === 1 ? '' : 's'}`}
    />
  );
};
